export const mapIdsToRows = <T extends { id: string }>(ids: Set<string>, tableData?: T[]): T[] => {
    if (!tableData?.length) {
        return [];
    }

    const rowMap = new Map(tableData.map((row) => [row.id, row]));
    return [...ids].map((id) => rowMap.get(id)).filter(Boolean) as T[];
};
